import { useEffect, useState } from "react";
import axios from "axios";
import { API_get_prep_history } from "../../../constants";
import { getDefaultAxiosConfig } from "../../../utilities/requests";

// The last week of pulls for a location. Separate from the plan because it
// reads about nine weeks of sales; `refreshKey` reloads it after results change.
export default function usePrepHistory(storeId, refreshKey) {
  const [state, setState] = useState({ days: null, loading: true, error: false });

  useEffect(() => {
    if (!storeId) return undefined;
    const source = axios.CancelToken.source();
    // A refresh keeps the rows on screen, but another location's never stay.
    setState(previous => ({ days: previous.storeId === storeId ? previous.days : null, storeId, loading: true, error: false }));
    axios.get(API_get_prep_history, { ...getDefaultAxiosConfig(), params: { store_id: storeId }, cancelToken: source.token, timeout: 60000 })
      .then((response) => {
        const days = response.data?.redux?.payload?.days;
        setState({ days: Array.isArray(days) ? days : [], storeId, loading: false, error: false });
      })
      .catch((error) => {
        if (!axios.isCancel(error)) setState(previous => ({ ...previous, loading: false, error: true }));
      });
    return () => source.cancel();
  }, [storeId, refreshKey]);

  return state;
}
